import { Colors } from '../../shared/colors/colors';
import styled, { css } from 'styled-components';
import { Fonts } from '../../shared/fonts/fonts';

// Estilo compartilhado para garantir que o texto fique preto quando tem valor
const filledTextStyle = css`
  color: ${Colors.black} !important;
  -webkit-text-fill-color: ${Colors.black} !important;
  text-fill-color: ${Colors.black} !important;
`;

// Estilo compartilhado para garantir que o placeholder fique cinza
const placeholderStyle = css`
  color: ${Colors.placeholder} !important;
  -webkit-text-fill-color: ${Colors.placeholder} !important;
  text-fill-color: ${Colors.placeholder} !important;
`;

export const Input = styled.input<{
  color: string;
  id: string;
  placeholder: string;
  error: boolean;
  disabled?: boolean;
}>`
  color: ${(props) => (props.error ? Colors.error : props.color)};
  background-color: ${Colors.white};
  width: 100%;
  height: 100%;
  border: none;
  border-radius: 8px;
  padding: 12px;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  line-height: 24px;
  height: 48px;
  font-family: ${Fonts.primary};
  font-size: 14px;

  &:disabled {
    background-color: #f5f5f5 !important;
    opacity: 0.7 !important;
    cursor: not-allowed !important;
    border: 1px solid #e0e0e0 !important;
     color: ${Colors.disabledInputText} !important;
  }

  &::placeholder {
    font-family: ${Fonts.primary};
    color: ${Colors.label};
  }
  &:focus {
    outline: none;
    box-shadow: none;
  }
  
  /* Para garantir que o tipo date tenha comportamento consistente */
  &[type="date"] {
    color: ${Colors.black};
    
    &::-webkit-calendar-picker-indicator {
      cursor: pointer;
    }
    
    &::-webkit-datetime-edit {
      color: ${Colors.black};
    }
    
    /* Aplica cor de placeholder para o campo quando está vazio */
    &:placeholder-shown::-webkit-datetime-edit,
    &:not(:valid)::-webkit-datetime-edit,
    &:empty::-webkit-datetime-edit {
      color: ${Colors.placeholder};
    }
  }
  
  /* Garantir texto preto para campos com valor */
  &.date-with-value,
  &:not(:placeholder-shown),
  &[value]:not([value=""]) {
    ${filledTextStyle}
  }
  
  /* Garantir texto cinza para placeholders */
  &.date-placeholder,
  &:placeholder-shown,
  &:not([value]),
  &[value=""] {
    ${placeholderStyle}
  }
`;

export const InputContainer = styled.div<{
  hasIconLeft: boolean;
  hasIconRight: boolean;
  width?: number;
  error: boolean;
}>`
  width: ${(props) => props.width ? `${props.width}px` : "100%"};
  display: flex;
  align-items: center;
  justify-content: start;
  border: 1px solid
    ${(props) => (props.error ? Colors.error : Colors.borderInput)};
  border-radius: 8px;
  padding-left: ${(props) => (props.hasIconLeft ? 19 : 0)}px;
  padding-right: ${(props) => (props.hasIconRight ? 19 : 0)}px;
  background-color: ${Colors.white};
`;

export const DatePickerInputContainer = styled.div<{
  hasIconLeft: boolean;
  hasIconRight: boolean;
  width: number;
  error: boolean;
}>`
  width: ${(props) => props.width}px;
  display: flex;
  align-items: center;
  justify-content: start;
  border: 1px solid
    ${(props) => (props.error ? Colors.error : Colors.borderInput)};
  border-radius: 8px;
  padding-left: ${(props) => (props.hasIconLeft ? 19 : 0)}px;
  padding-right: ${(props) => (props.hasIconRight ? 19 : 0)}px;
  background-color: transparent;
  z-index: 99999;
  /* Placeholder sempre cinza */
  .date-picker-input::placeholder {
    color: ${Colors.placeholder} !important;
    font-family: ${Fonts.primary};
  }
  
  /* Garantir que a data selecionada seja preta */
  .date-picker-input {
    color: ${Colors.black};
    
    &:placeholder-shown,
    &:not(:valid),
    &:empty {
      ${placeholderStyle}
    }
    
    &:not(:placeholder-shown) {
      ${filledTextStyle}
    }
  }
  
  /* Correção para o DatePicker */
  .react-datepicker-wrapper {
    width: 100%;
    
    .react-datepicker__input-container {
      width: 100%;
      
      input {
        width: 100%;
        
        &:not(:placeholder-shown) {
          ${filledTextStyle}
        }
        
        &:placeholder-shown {
          ${placeholderStyle}
        }
      }
    }
  }
  
  /* Correção específica para o texto preenchido */
  &:has(.has-value) input,
  &:has(input:not(:placeholder-shown)) {
    ${filledTextStyle}
  }
  
  /* Correção para a classe has-date-content */
  &.has-date-content {
    .react-datepicker-wrapper,
    .react-datepicker__input-container,
    .react-datepicker__input-container input,
    input,
    .date-picker-input {
      ${filledTextStyle}
    }
  }
  
  /* Correção para campos de data nativo */
  input[type="date"] {
    color: ${Colors.black};
    
    &::placeholder {
      ${placeholderStyle}
    }
    
    /* Quando o campo está vazio, usar cor de placeholder */
    &:not(:valid),
    &:placeholder-shown,
    &:empty {
      ${placeholderStyle}
    }
    
    /* Quando tem valor, garantir que o texto seja preto */
    &:valid:not(:placeholder-shown):not(:empty) {
      ${filledTextStyle}
    }
  }
`;
